export default {
  loading: false,
  practicesFilters: {},
  practices: [],
  practice: {},
  pagination: {},
  practicePatientsFilters: {},
  practicePatients: [],
  practiceUsersFilters: {},
  practiceUsers: [],
  practiceUser: {},
  practiceUserPatients: [],
  practiceUserPatientsPagination: {},
  practiceUserAdvisorsDashboard: null
}